import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import CollectionModalUI from './CollectionModalUI.js'

class CollectionModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      collectionDate: '',
      collectionDateError: null,
      balanceAmount: '',
      balanceAmountError: null
    }
  }

  render() {
    return (
      <CollectionModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        collectionDate={this.state.collectionDate}
        onCollectionDateChange={(collectionDate) => { this.setState({ collectionDate: collectionDate }) }}
        collectionDateError={this.state.collectionDateError}
        setCollectionDateError={(error) => { this.setState({ collectionDateError: error }) }}
        balanceAmount={this.state.balanceAmount}
        onBalanceAmountChange={(event) => { this.setState({ balanceAmount: event.target.value }) }}
        balanceAmountError={this.state.balanceAmountError}
        setBalanceAmountError={(error) => { this.setState({ balanceAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/invoiceDiscounting/collections`,
      this.onSubmitCallback, {
      collectionDate: this.state.collectionDate,
      balanceAmountF: this.state.balanceAmount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default CollectionModalSF
